import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./MainTabContent.css";
import "../../study.css"
import { studiesService } from "../../../../service";

const MainTabContent = ({ studyId }) => {

  const [study, setStudy] = useState(null);

  useEffect(() => {
    const fetchStudy = async () => {
      try {
        const token = localStorage.getItem("token");
        const req = await studiesService.getById(studyId, token);
        const data = req.data;
        setStudy(data);
      } catch (error) {
        console.error("Error fetching study details:", error);
      }
    };

    if (studyId) {
      fetchStudy();
    }
  }, [studyId]);

  if (!study) return <p></p>;

  return (
    <div className="overflow-y-auto px-0" style={{ height: "100%" }}>
      <div className="container-fluid">
        <div className="row g-3">
          <div className="col-6">
            <div className="main-info bg-white py-2 px-4 shadow-sm">
              <span className="tab-title d-block">Nom de l'étude</span>
              <span style={{ fontWeight: "500", fontSize: "0.9rem" }}>
                {study.name}
              </span>
            </div>
          </div>
          <div className="col-6">
            <div className="main-info bg-white py-2 px-4 shadow-sm">
              <span className="tab-title d-block">Contact de l'étude</span>
              <span style={{ fontWeight: "500", fontSize: "0.9rem" }}>
                {study.contact}
              </span>
            </div>
          </div>
        </div>

        {/* Collapsible Sections */}
        <div className="row g-3 px-2 py-0 mt-2">
          <a
            className="collapsable-btn p-3 d-flex justify-content-between align-items-center"
            data-bs-toggle="collapse"
            href="#collapseResume"
            role="button"
            aria-expanded="false"
            aria-controls="collapseResume"
          >
            <span>Résumé de l'étude</span>
            <FaChevronDown />
          </a>
          <div className="collapse text-div py-2 px-3" id="collapseResume">
            <div
              className="html-content"
              dangerouslySetInnerHTML={{ __html: study.abstract }}
            />
          </div>

          <a
            className="collapsable-btn p-3 d-flex justify-content-between align-items-center"
            data-bs-toggle="collapse"
            href="#collapseProtocole"
            role="button"
            aria-expanded="false"
            aria-controls="collapseProtocole"
          >
            <span>Protocole de l'étude</span>
            <FaChevronDown />
          </a>
          <div className="collapse text-div py-2 px-3" id="collapseProtocole">
            <div
              className="html-content"
              dangerouslySetInnerHTML={{ __html: study.protocol }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainTabContent;
